module.exports = {"headerTitle":"Import subjektů","headerTitleResults":"Výsledek importu subjektů","close":"Storno","ok":"OK"}